export default {
  toApiFormat(dateString: string): string {
    const dateBits = dateString.split('/')
    return `${dateBits[2]}-${dateBits[0]}-${dateBits[1]}`
  },

  formatBirthday(birthday: string): string {
    const dateBits = birthday.split('-')
    return `${dateBits[1]}-${dateBits[2]}-${dateBits[0]}`
  },

  formatMonthYear(dateString: string): string {
    const dateBits = dateString.split('-')
    return `${dateBits[1]}-${dateBits[0]}`
  },

  isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
  },

  getDaysInMonth(year: number, month: number): number {
    return [
      31,
      this.isLeapYear(year) ? 29 : 28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ][month]
  },

  addMonths(date: Date, value: number) {
    const d = new Date(date)
    const n = date.getDate()
    d.setDate(1)
    d.setMonth(d.getMonth() + value)
    d.setDate(Math.min(n, this.getDaysInMonth(d.getFullYear(), d.getMonth())))
    return d
  },

  calculateAge(dateString: string) {
    const today = new Date()
    const birthDate = new Date(dateString)
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  },

  calculateTimeRemaining(term, date) {
    const durationInMonths = term
    let startDate = new Date(String(date) + ' 00:00:00')
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    if (startDate > today) {
      return durationInMonths
    }

    startDate = this.addMonths(startDate, 1)

    let monthsSinceStart = 0
    while (startDate <= today) {
      if (monthsSinceStart > durationInMonths) {
        return 0
      }
      startDate = this.addMonths(startDate, 1)
      monthsSinceStart += 1
    }

    return durationInMonths - monthsSinceStart
  },
}
